import { cloneDeep } from 'lodash';

let uniqIdCounter = 0;

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
const excludeIntacctId = (d) => {
  const id = d.externalId;
  if (id) {
    d.name = d.name?.replace(`${id}--`, '');
  }
  return d;
};

const includeIntacctId = (d) => {
  const id = d.externalId;
  if (id) {
    const textToPrepend = `${id}--`;
    d.name = d.name?.includes(textToPrepend) ? d.name : `${textToPrepend}${d.name}`;
  }
  return d;
};

const loadingChunkRetry = (fn, retriesLeft = 5, interval = 1000) => {
  return new Promise((resolve, reject) => {
    fn()
      .then(resolve)
      .catch((error) => {
        setTimeout(() => {
          if (retriesLeft === 1) {
            // reject('maximum retries exceeded')
            reject(error);
            return;
          }

          // Passing on 'reject' is the important part
          loadingChunkRetry(fn, retriesLeft - 1, interval * (6 - retriesLeft)).then(resolve, reject);
        }, interval);
      });
  });
};

const deepSearchGroupedApprovals = (data, query, AllowedObjectKeys) => {
  return data.filter((d) => {
    const search = query.toLowerCase();
    if (d.name?.toLowerCase().indexOf(search) > -1) return true;
    d.data = d.data.filter((_d) => {
      return AllowedObjectKeys.find((key) => {
        const val = _d[key];
        if (typeof val === 'string') return val?.toLowerCase().indexOf(search) > -1;
        if (Array.isArray(val)) return val.find((v) => v?.toLowerCase().indexOf(search) > -1);
        if (typeof val === 'object') return val.name?.toLowerCase().indexOf(search) > -1;
        return false;
      });
    });
    return d.data?.length;
  });
};

const searchInTodoProjectData = (data, query) => {
  return data.filter((d) => {
    const search = query.toLowerCase();
    if (d.key?.name.toLowerCase().indexOf(search) > -1) return true;
    return d.data.find((e) => e.client?.name.toLowerCase().indexOf(search) > -1);
  });
};

const groupByTimesheet = (projectEntries) => {
  const timesheets = [];
  projectEntries.map((entry) => {
    const timesheet = cloneDeep(entry.timesheet);
    const existingIndex = timesheets.findIndex((t) => t.timesheet_id === timesheet.timesheet_id);
    const _entry = cloneDeep(entry);
    delete _entry.employee;
    delete _entry.timesheet;
    if (existingIndex > -1) {
      timesheets[existingIndex].entries.push(_entry);
    } else {
      timesheets.push({
        ...entry.timesheet,
        entries: [_entry],
      });
    }
    return null;
  });
  return timesheets;
};

function* uniqIdGenerator() {
  while (true) {
    yield Date.now().toString() + (uniqIdCounter++).toString();
  }
}

const sortObjectsByNameAsc = (a, b) => a.name.localeCompare(b.name);

const sortByDate = (dataToSort, propertyToSortBy, order) => {
  const sortedData = dataToSort.sort((a, b) => {
    const formatedAValue = a[propertyToSortBy]?.replace(' +', '+');
    const formatedBValue = b[propertyToSortBy]?.replace(' +', '+');
    if (order === 'ascending') return new Date(formatedAValue) - new Date(formatedBValue);
    if (order === 'descending') return new Date(formatedBValue) - new Date(formatedAValue);
    return 0;
  });

  return sortedData;
};

const sortByNumber = (dataToSort, propertyToSortBy, order) => {
  const sortedData = dataToSort.sort((a, b) => {
    const parsedValueA = parseInt(a[propertyToSortBy]);
    const parsedValueB = parseInt(b[propertyToSortBy]);

    if (order === 'ascending') return parsedValueA - parsedValueB;
    if (order === 'descending') return parsedValueB - parsedValueA;
    return 0;
  });

  return sortedData;
};

const sortByString = (dataToSort, propertyToSortBy, order) => {
  const sortedData = dataToSort.sort((a, b) => {
    const stringA = a[propertyToSortBy]?.toUpperCase() || '';
    const stringB = b[propertyToSortBy]?.toUpperCase() || '';

    if (order === 'ascending') return stringA.localeCompare(stringB);
    if (order === 'descending') return stringB.localeCompare(stringA);
    return 0;
  });

  return sortedData;
};

const capitalizeFirstLetter = (string = '') => {
  return `${string.charAt(0).toUpperCase()}${string.slice(1)}`;
};

export {
  capitalizeFirstLetter,
  deepSearchGroupedApprovals,
  excludeIntacctId,
  groupByTimesheet,
  includeIntacctId,
  loadingChunkRetry,
  searchInTodoProjectData,
  sleep,
  sortByDate,
  sortByNumber,
  sortByString,
  sortObjectsByNameAsc,
  uniqIdGenerator,
};
